export default "__VITE_ASSET__C4T3FKvf__"